import {takeLatest} from "redux-saga/effects";
import {
  addAreas,
  addCities, bulkUpdate,
  enableDisableArea,
  enableDisableCity,
  enableDisableProvince,
  fetchAreasByCity,
  fetchCitiesByProvince,
  fetchProvinces, modifyArea,
  renameCity,
  renameProvince
} from "../slices/locationSlice";
import {
  handleGetAreasByCity,
  handleGetCitiesByProvince,
  handleGetProvinces,
  handlePatchArea,
  handlePatchCity,
  handlePatchProvince, handlePostArea,
  handlePostCity,
  handlePutArea,
  handlePutCity, handlePutLocation,
  handlePutProvince
} from "./handlers/locationHandler";

const locationSaga = [
  takeLatest(fetchProvinces.type, handleGetProvinces),
  takeLatest(fetchCitiesByProvince.type, handleGetCitiesByProvince),
  takeLatest(fetchAreasByCity.type, handleGetAreasByCity),
  takeLatest(renameProvince.type, handlePutProvince),
  takeLatest(addCities.type, handlePostCity),
  takeLatest(renameCity.type, handlePutCity),
  takeLatest(enableDisableProvince.type, handlePatchProvince),
  takeLatest(enableDisableCity.type, handlePatchCity),
  takeLatest(addAreas.type, handlePostArea),
  takeLatest(modifyArea.type, handlePutArea),
  takeLatest(enableDisableArea.type, handlePatchArea),
  takeLatest(bulkUpdate.type, handlePutLocation),
]

export default locationSaga